import { render, staticRenderFns } from "./adultosScreen.vue?vue&type=template&id=2edaa44e"
import script from "./adultosScreen.vue?vue&type=script&lang=js"
export * from "./adultosScreen.vue?vue&type=script&lang=js"
import style0 from "./adultosScreen.vue?vue&type=style&index=0&id=2edaa44e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports